import { render } from "./preview3d.vue?vue&type=template&id=8b63d24c&scoped=true"
import script from "./preview3d.vue?vue&type=script&lang=js"
export * from "./preview3d.vue?vue&type=script&lang=js"

import "./preview3d.vue?vue&type=style&index=0&id=8b63d24c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b63d24c"]])

export default __exports__